import {Action, createReducer, on} from '@ngrx/store';
import * as dibujosActions from './dibujos.actions';
import {dibujosAdapter, DibujosState, initialState} from './dibujos.state';

const reducer = createReducer(initialState,
  on(dibujosActions.addDibujo, (state, {dibujo}) => {
    return dibujosAdapter.addOne(dibujo, state);
  }),
  on(dibujosActions.addDibujos, (state, {dibujos}) => {
    return dibujosAdapter.addMany(dibujos, state);
  }),
  on(dibujosActions.updateDibujo, (state, {update}) => {
    return dibujosAdapter.updateOne(update, state);
  }),
  on(dibujosActions.updateDibujos, (state, {updates}) => {
    return dibujosAdapter.updateMany(updates, state);
  }),
  on(dibujosActions.deleteDibujo, (state, {id}) => {
    return dibujosAdapter.removeOne(id, state);
  }),
  on(dibujosActions.deleteDibujos, (state, {ids}) => {
    return dibujosAdapter.removeMany(ids, state);
  }),
  on(dibujosActions.loadDibujos, (state, {dibujos}) => {
    return dibujosAdapter.setAll(dibujos, state);
  }),
  on(dibujosActions.clearDibujos, state => {
    return dibujosAdapter.removeAll({...state});
  }),

  on(dibujosActions.loadingDibujos, (state, {isLoading, error}) => {
    return {
      ...state,
      isLoading,
      error
    };
  })
);

export function dibujosReducer(state: DibujosState | undefined, action: Action) {
  return reducer(state, action);
}
